import { getLogger, MESSAGE_TYPES as MSG_TYPES } from '@cld/upload-widget';
import postmessage from 'utils/postmessage';
import { types as ats } from './store/actions';
import { createUploadFileFromData } from './common/utils';

const logger = getLogger();

export default (options) => {
  const registeredHandlers = {
    [MSG_TYPES.PRE_BATCH]: [],
    [MSG_TYPES.PREPARE]: [],
    [MSG_TYPES.METADATA_SCHEMA]: [],
  };

  const runTypeHandlers = (handlerType, data) => registeredHandlers[handlerType].splice(0).forEach((handler) => handler(data));

  const initHandler = (data) => {
    logger.log('[uploader.externalInterface]: received init message ', data.type, data.name, data.size);
    options.actions[ats.SET_UPLOADER_CONFIG]({ config: data });
  };

  const configHandler = (data) => {
    logger.log('[uploader.externalInterface]: received updated config ', data.type, data.name, data.size);
    options.actions[ats.SET_UPLOADER_CONFIG]({ config: data });
  };

  const prepareHandler = (data) => {
    logger.log('[uploader.externalInterface]: received prepared upload params ', data.type, data.name, data.size);
    runTypeHandlers(MSG_TYPES.PREPARE, data);
  };

  const showHandler = (data) => {
    logger.log('[uploader.externalInterface]: received show message ', data.type, data.name, data.size);
    options.actions[ats.SET_UPLOADER_SHOW](data);
  };

  const hideHandler = (data) => {
    logger.log('[uploader.externalInterface]: received hide message');
    options.actions[ats.SET_UPLOADER_HIDE]({ options: data });
  };

  const tagsHandler = (data) => {
    logger.log('[uploader.externalInterface]: received tags', data.type, data.name, data.size);
    options.actions[ats.SET_UPLOADER_RETRIEVED_TAGS](data);
  };

  const uploadPresetsHandler = (data) => {
    logger.log('[uploader.externalInterface]: received upload-presets', data);
    options.actions[ats.SET_UPLOADER_RETRIEVED_UPLOAD_PRESETS](data);
  };

  const minimizeHandler = () => {
    logger.log('[uploader.externalInterface]: received minimize message');
    options.actions[ats.SET_UPLOADER_MINIMIZE]();
  };

  const fileHandler = async (data) => {
    logger.log('[uploader.externalInterface]: received upload file ', data.type, data.name, data.size);

    options.actions[ats.SET_UPLOADER_ADD_CLIENT_UPLOAD]({
      file: await createUploadFileFromData(data),
      index: data.index,
      count: data.count,
      batchId: data.batchId,
    });
  };

  const preBatchHandler = (data) => {
    data = data || {};
    logger.log('[uploader.externalInterface]: received pre-batch callback ', data.type, data.name, data.size);
    runTypeHandlers(MSG_TYPES.PRE_BATCH, data);
  };

  const clientBatchHandler = (data) => {
    logger.log(`[uploader.externalInterface]: received client batch start event. batch id = ${data.batchId}`);
    options.actions[ats.SET_UPLOADER_START_CLIENT_BATCH]({
      count: data.count,
      batchOptions: data.batchOptions,
      batchId: data.batchId,
    });
  };

  const metadataSchemaHandler = (data) => {
    logger.log('[uploader.externalInterface]: received metadata schema callback ', data);
    runTypeHandlers(MSG_TYPES.METADATA_SCHEMA, data);
  };

  const pm = postmessage(self.parent, {
    target: options.qsParams.pmHost,
    types: {
      [MSG_TYPES.INIT]: initHandler,
      [MSG_TYPES.CONFIG]: configHandler,
      [MSG_TYPES.PREPARE]: prepareHandler,
      [MSG_TYPES.SHOW]: showHandler,
      [MSG_TYPES.HIDE]: hideHandler,
      [MSG_TYPES.TAGS]: tagsHandler,
      [MSG_TYPES.UPLOAD_PRESETS]: uploadPresetsHandler,
      [MSG_TYPES.MINIMIZE]: minimizeHandler,
      [MSG_TYPES.FILE]: fileHandler,
      [MSG_TYPES.PRE_BATCH]: preBatchHandler,
      [MSG_TYPES.CLIENT_BATCH]: clientBatchHandler,
      [MSG_TYPES.METADATA_SCHEMA]: metadataSchemaHandler,
    },
  });

  const sendExternalWithHandler = (handlerType, handler, data) => {
    registeredHandlers[handlerType].push(handler);
    return pm.send({
      ...data,
      type: handlerType,
    });
  };

  return {
    emitEvent: (data) =>
      pm.send({
        type: MSG_TYPES.EVENT,
        ...data,
      }),

    requestPrepareParams: (handler, data) => sendExternalWithHandler(MSG_TYPES.PREPARE, handler, data),

    sendPreBatch: (handler, data) => sendExternalWithHandler(MSG_TYPES.PRE_BATCH, handler, data),

    requestMetadataSchema: (handler, data) => sendExternalWithHandler(MSG_TYPES.METADATA_SCHEMA, handler, data),

    requestTags: (data) =>
      pm.send({
        type: MSG_TYPES.TAGS,
        ...data,
      }),

    requestUploadPresets: (data) => {
      pm.send({
        type: MSG_TYPES.UPLOAD_PRESETS,
        ...data,
      });
    },

    sendHide: (data) =>
      pm.send({
        type: MSG_TYPES.HIDE,
        ...data,
      }),
  };
};
